import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';
import FemaleSpeakerImage from '@/assets/images/presentation/female-speaker.png';

export const PurpleGradientSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="linear-gradient(180deg, rgba(170, 138, 247, 0.75) 0%, rgba(170, 138, 247, 0.00) 100%)"
      bgRepeat="no-repeat"
      pt={{ base: 6, lg: 16 }}
      pb={16}
    >
      <Container>
        <Flex maxW="1000px" margin="auto" flexDirection={{ base: 'column', lg: 'row' }} gap={4}>
          <Flex flex={1} justifyContent="center">
            <Image src={FemaleSpeakerImage} alt="Conference crew" />
          </Flex>
          <Flex flex={1} justifyContent="center" flexDirection="column">
            <Text>{t('inPersonEventsPage.purpleSectionText')}</Text>
            <Button
              as={Link}
              href="/contact-us/conferences"
              variant="solid"
              alignSelf="flex-start"
              mt={6}
              rightIcon={<ArrowIcon />}
            >
              {t('newEventPage.getStarted')}
            </Button>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
